import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { COUNTRIES } from "../lib/countries";
import { track } from "./../lib/analytics";

export const CountryGrid = () => {
  return (
    <section
      data-testid="country-grid"
      className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-32"
    >
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8 sm:mb-12">
        <div>
          <span className="kicker">— Destinations</span>
          <h2 className="font-serif text-3xl sm:text-5xl mt-3 max-w-2xl text-slate-900">
            Twelve handpicked countries.
            <br />
            <span className="italic" style={{ color: "#2A7FB8" }}>
              One co-pilot.
            </span>
          </h2>
        </div>
        <p className="text-slate-600 max-w-sm text-sm leading-relaxed">
          Tap a card to open the country experience — flights, stays,
          activities, food and an AI expert tuned to that destination.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] gap-3 sm:gap-4">
        {COUNTRIES.map((c, idx) => {
          const span = c.span;
          const colClass =
            span === "wide" ? "md:col-span-2" : "md:col-span-1";
          const rowClass =
            span === "tall" ? "row-span-2 md:row-span-2" : "row-span-1";
          return (
            <Link
              key={c.slug}
              to={`/experts/${c.slug}`}
              data-testid={`country-card-${c.slug}`}
              onClick={() =>
                track("country_card_clicked", { country: c.slug })
              }
              className={`relative group overflow-hidden rounded-2xl ring-1 ring-slate-200/70 shadow-sm hover:shadow-xl transition-all ${colClass} ${rowClass}`}
              style={{ background: "#ffffff" }}
            >
              <img
                src={c.image}
                alt={c.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to top, rgba(11,37,69,0.85) 0%, rgba(11,37,69,0.15) 50%, transparent 100%)",
                }}
              />
              <div className="relative h-full flex flex-col justify-between p-4 sm:p-5">
                <div className="flex justify-between items-start">
                  <span className="font-mono text-[10px] tracking-widest text-white/95 px-2 py-1 rounded-full bg-white/15 backdrop-blur-md border border-white/25">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-white/95 w-7 h-7 rounded-full grid place-items-center">
                    <ArrowUpRight size={14} color="#2A7FB8" weight="bold" />
                  </span>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.25em] text-[#FFD7A8] mb-1">
                    {c.visa}
                  </div>
                  <div className="font-serif text-2xl sm:text-3xl leading-tight text-white">
                    {c.name}
                  </div>
                  <div className="text-xs text-white/85 mt-1 line-clamp-1">
                    {c.tagline}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};
